import React, { useState } from 'react';
import AccordionItem from './AccordionItem';

const Accordion = ({ items }) => {
  
  // --- VOLVEMOS A LA NORMALIDAD ---
  // El estado inicial vuelve a 'null' (todos cerrados)
  const [openIndex, setOpenIndex] = useState(null);
  // ---------------------------------

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="accordion-container">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          index={index}
          title={item.title}
          description={item.description}
          videoId={item.videoId}
          isOpen={openIndex === index}
          onToggle={handleToggle}
        />
      ))}
    </div>
  );
};

export default Accordion;